import { Overlay, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ElementRef, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PalantirSelectItemOverlayComponent } from './select-item-overlay.component';
import type { PalantirSelectItemOverlayOptions } from './select-item-overlay.type';

@Injectable({
  providedIn: 'root',
})
export class PalantirSelectItemOverlayService {
  public constructor(
    private readonly overlay: Overlay,
    private readonly overlayPositionBuilder: OverlayPositionBuilder,
  ) {}

  public async open<T>(
    triggerElement: ElementRef<HTMLElement>,
    options: PalantirSelectItemOverlayOptions<T>,
  ): Promise<{ data?: any[]; role: 'success' }> {
    const overlayRef = this.overlay.create({
      hasBackdrop: true,
      width: options.width ?? '300px',
      height: options.height ?? '300px',
      positionStrategy: this.overlayPositionBuilder
        .flexibleConnectedTo(triggerElement)
        .withPositions([
          {
            originX: 'center',
            originY: 'bottom',
            overlayX: 'center',
            overlayY: 'top',
          },
        ]),
    });

    const portal = new ComponentPortal(PalantirSelectItemOverlayComponent);
    const componentRef = overlayRef.attach(portal);

    componentRef.instance.data = options;
    componentRef.instance.overlayRef = overlayRef;
    componentRef.instance.initializeData();

    await firstValueFrom(overlayRef.backdropClick());

    overlayRef.dispose();

    const data = componentRef.instance.model.selected;

    return { data, role: 'success' };
  }
}
